import { Argomento } from './tipologiche/argomento';
import { Materia } from './tipologiche/materia';
import { Oggetto } from './tipologiche/oggetto';


export class Classificazione {
  id?: string;
  materia?: Materia;
  oggetto?: Oggetto;
  argomento?: Argomento;
  isPrincipale?: boolean;
}
